import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { UserIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { AiActivityTestIds } from '../AiActivity.testIds';

import { avatarStyles, initialsStyles, systemAvatarStyles } from './TriggerAvatar.styles';
import { resolveInitials } from './TriggerAvatar.utils';

const TriggerAvatar = ({ name = null }) => {
  const initials = resolveInitials(name);

  if (initials === null) {
    return (
      <Box data-testid={AiActivityTestIds.TRIGGER_AVATAR} sx={systemAvatarStyles}>
        <UserIcon size={IconSize[12]} />
      </Box>
    );
  }

  return (
    <Box data-testid={AiActivityTestIds.TRIGGER_AVATAR} sx={avatarStyles}>
      <Typography sx={initialsStyles} variant="bold12">
        {initials}
      </Typography>
    </Box>
  );
};

TriggerAvatar.propTypes = {
  name: PropTypes.string,
};

export default memo(TriggerAvatar);
